import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs';

import * as _ from 'lodash';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

import { LoginAttempt } from '../../classes/loginAttempt';

@Injectable()
export class LoginAttemptService extends UserService{

  protected getUsersUrl(): string {

    return 'loginAttempts';
  };

  protected getOneUserUrl(): string {

    return 'loginAttempt';
  };

  protected parseObject(obj: any): LoginAttempt {

    return obj as LoginAttempt;
  };

  protected parseArray(objs: any): LoginAttempt[] {

    return objs as LoginAttempt[];
  };

  constructor(protected requestService: RequestService, protected auth: Auth) { 
    super(requestService, auth);
  };

};


// WEBPACK FOOTER //
// ./src/app/services/loginAttempts/loginAttempts.service.ts